// extracted by mini-css-extract-plugin
module.exports = {"emptyContainer":"EmptyNotifications_emptyContainer__QHywl","icon":"EmptyNotifications_icon__2T37X","emptyMessage":"EmptyNotifications_emptyMessage__S1quW"};